import clsx from "clsx"
import React, { forwardRef, memo } from "react"
import { createPortal } from "react-dom"
import styled from "styled-components"
import cn from "clsx"
import IconClose from "../icons/IconClose"

export const ModalContent = styled.div`
  flex-direction: column;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  z-index: 1000;
  padding: 24px;

  min-height: 200px;
  min-width: 200px;

  max-height: 100%;
  max-width: 100%;

  display: flex;

  background: #fff;
  &.openModal {
    transform: translate(-50%, -50%) scale(1);
  }

  &.size-sm {
    width: 400px;
  }

  &.size-md {
    width: 640px;
  }

  &.size-1-lg {
    width: 800px;
  }

  &.size-2-lg {
    width: 980px;
  }
`

export const ButtonClose = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
`

const Overlay = styled.div`
  &.overlay {
    cursor: not-allowed;
    position: fixed;
    display: flex;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(23, 20, 20, 0.3);
    z-index: 999;
  }
`

const ModalDiv = styled.div``

interface ModalProps {
  children?: React.ReactElement
  className?: string
  openModal: boolean
  closeModal?: () => void
  title?: string
  size?: "sm" | "md" | "1-lg" | "2-lg"
}

const ModalComponent: React.FC<ModalProps> = forwardRef<HTMLDivElement, ModalProps>((props, ref) => {
  const { children, className, openModal, closeModal, title, size, ...rest } = props

  return (
    <ModalDiv {...rest} ref={ref} className={className}>
      {openModal && (
        <Overlay className="overlay">
          {createPortal(
            <ModalContent className={clsx({ openModal: openModal }, "shelf-modal-body", cn(`size-${size}`))}>
              {closeModal && (
                <ButtonClose onClick={closeModal}>
                  <IconClose />
                </ButtonClose>
              )}
              {title && <span>{title}</span>}
              {children}
            </ModalContent>,
            document.getElementById("portal") as HTMLElement
          )}
        </Overlay>
      )}
    </ModalDiv>
  )
})

export default memo(ModalComponent)
